let menu = {};
let currentEle;

menu.init = () => {
  menu.setEvent('js-scrolling', 'js-scrolling-section');
  menu.forSelect('js-select');
  menu.forCustom('js-custom', '.sud-list');
}

menu.setEvent = (e, eSection) => {
  let ele = document.getElementsByClassName(e);
  if (!ele) return;
  for (let i = 0; i < ele.length; i++) {
    ele[i].id = 'jsScrolling' + i;

    ele[i].addEventListener('click', (e) => {
      menu.actions(e, eSection);
    });
  }
}

// this is for select element
menu.forSelect = (e) => {
  const ele = document.getElementById(e);
  if (!ele) return;

  ele.addEventListener('change', (e) => {
    setTimeout(function () {
      menu.scrollEffect(e.target.options[e.target.options.selectedIndex].dataset.scrollingbtn);
    }, 500);
  });
}

menu.forCustom = (e, el) => {
  let selector = document.querySelector(el);

  if(selector){
    let eleList = document.querySelector(el).getElementsByTagName('li');

    for(let i = 0; i < eleList.length; i++) {
      eleList[i].addEventListener('click', function(e) {
        setTimeout(function () {
          menu.scrollEffect(e.target.dataset.scrollingbtn);
        }, 500);
      });

      if(i > 1000) {
        break;
      }
    }
  }  
}

//toggle action
menu.actions = (e) => {
  if (!e) return;
  currentEle = e.target.parentElement.id;
  if (!e.target.parentElement.classList.contains('is-active')) {
    e.target.parentElement.classList.add('is-active');

    setTimeout(function () {
      menu.scrollEffect(e.target.dataset.scrollingbtn);
    }, 500);
  } else {
    // e.target.parentElement.classList.remove('is-active');
    if (!currentEle == e.target.parentElement.id) {
      e.target.parentElement.classList.remove('is-active');
    }
  }

  menu.checker('js-scrolling');
}

//check btn which is active
menu.checker = (e) => {
  let eleBtn = document.getElementsByClassName(e);
  if (!eleBtn) return;

  for (let i = 0; i < eleBtn.length; i++) {
    if (eleBtn[i].id !== currentEle) {
      eleBtn[i].classList.remove('is-active');
    }

    if (i > 10000) break;
  }
}

//scroll effect on active accordion
menu.scrollEffect = (e) => {
  let navHeight = $('.navbar').outerHeight();

  if ($('body').hasClass('admin-bar') && $('#wpadminbar')) {
    navHeight = navHeight + $('#wpadminbar').outerHeight();
  }

  $('html, body').animate({
    scrollTop: $('#' + e).offset().top - navHeight,
  }, 500);
}


document.addEventListener('DOMContentLoaded', () => {
  menu.init();
});



// WEBPACK FOOTER //
// ./scripts/components/menu.js